'use strict';

const React = require( 'react' );
const getAirportInfo = require( '../getAirportInfo' );
const propTypes = require('prop-types');
const Helpers = require( '../../../../../_plugins/lib/helpers' );
const { array, object, string } = propTypes;
const createReactClass = require('create-react-class');

const GetCachedPrice = createReactClass({
  mixins: [Helpers],

  propTypes: {
    priceFormat: string,
    type: string,
    id: string,
    functionParams: array,
    pageData: object
  },

  getDefaultProps( ) {
    return {
      type: 'per_day',
      priceFormat: '£'
    };
  },

  getProduct( ) {
    let { functionParams, type, pageData: { productClass } } = this.props;
    if ( !type && functionParams[1] ) type = functionParams[1];
    productClass = productClass.toUpperCase( );
    let path = false;

    switch ( type ) {
    case 'perday':
      type = 'per_day';
      break;
    case 'perweek':
      type = 'per_week';
      break;
    }

    if ( productClass === 'HCP' || productClass === 'HO' ) {
      switch ( type ) {
      case 'days8':
        type = 'lowestDays8';
        break;
      case 'days15':
        type = 'lowestDays15';
        break;
      default:
        type = 'lowestPrice';
        break;
      }
    }

    switch ( productClass ) {
    case 'CP':
      path = 'parking/';
      break;
    case 'HCP':
      path = 'hotels/';
      break;
    case 'HO':
      path = ( type === 'lowestDays8' || type === 'lowestDays15' ) ? 'hotels/' : 'hotelOnly/';
      break;
    }

    if ( !path ) return false;
    return {
      path,
      type,
      productClass
    };
  },

  getPriceFromFeed( product ) {
    const { id, priceFormat, pageData: { pageName } } = this.props;
    if ( typeof window !== 'undefined' && this.$( '#' + id )) {
      return this.$( '#' + id ).innerHTML;
    }
    const airport = getAirportInfo( pageName );
    if ( !airport ) {
      if ( product.productClass === 'HO' || product.productClass === 'HCP' ) return priceFormat + '37'; // Default price for hotels
      return priceFormat + '23.92'; // Default price for parking
    }
    if ( airport.code.length === 3 ) { //Location price fetch
      try {
        const { prices } = require( '../../../../../config/exports/prices/' + product.path + airport.code + '.json' );
        if ( product.type && prices && prices[ product.type ] ) return priceFormat + prices[ product.type ];
        return false;
      } catch ( e ) {
        return false;
      }
    }
  },

  render( ) {
    const { id } = this.props;
    const product = this.getProduct( );
    const price = ( product ) ? this.getPriceFromFeed( product ) : false;
    return (
      <span id={ id } className="redFont">{ product && price && price }</span>
    );
  }
});

module.exports = GetCachedPrice;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/pricing/getCachedPrice.jsx